// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"506":"e0da344b","878":"c22435d6"}[chunkId] + ".chunk.js";
};